import { getAxiosClient } from "../../axios-client";
import {
  GetAllOffersPositionBody,
  GetAllOffersPositionResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const getAllOffersPosition = async (body: GetAllOffersPositionBody) => {
  return await axiosClient.ax.post<GetAllOffersPositionResponse>(
    "/Offers/GetAllOffersPossition",
    body
  );
};
